import { DesignTokens } from "./types";

export default {
  breakpoints: { mobile: 600, tablet: 999 },
  contentWidth: { large: "1024px" }
} as DesignTokens;
